import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Popover,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { colors } from "theme";
import { FilterBadgeWrapper } from "../styles";
import { Ptag } from "components/core";

function FilterBar({filters, onChange}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [filterStatusSelected, setFilterStatusSelected] = useState(new Set([]));
  const didMountRef = useRef(false);

  useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true;
      return;
    }
    onChange(filterStatusSelected);
  }, [filterStatusSelected, onChange]);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const filterHandler = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCheckbox = (status) => {
    if (filterStatusSelected.has(status)) {
      setFilterStatusSelected((prev) => {
        prev.delete(status);
        return new Set(prev);
      });
    } else {
      setFilterStatusSelected((prev) => {
        prev.add(status);
        return new Set(prev);
      });
    }
  };
  const isChecked = (status) => {
    return filterStatusSelected.has(status);
  };
  return (
    <>
    {filters && filters.length > 0 ? 
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        PaperProps={{
          // style: {
          //   boxShadow: "none",
          //   border: `1px solid #D0D5DD`,
          //   borderRadius: "10px"
          // },
          style: {
            marginTop: "8px",
            // border: "1px solid #D0D5DD",
            border: "1px solid rgba(255, 255, 255, 1)",
            boxShadow:
              "inset 2px 2px 5px rgba(0, 0, 0, 0.08), inset -1px -1px 3px rgba(255, 255, 255, 0.9)",
            "&:hover": {
              boxShadow:
                "inset 2px 2px 5px rgba(0, 0, 0, 0.08), inset -1px -1px 3px rgba(255, 255, 255, 0.9)",
              backgroundColor: "white",
            },
            borderRadius: "10px"
          },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <section>
          <FormControl
            style={{
              margin: "16px 24px",
            }}
            component="fieldset"
            variant="standard"
          >
            <FormGroup>
              {filters.map((status) => (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isChecked(status)}
                      onChange={() => handleCheckbox(status)}
                      name={status}
                      style={{
                        transform: "scale(1.4)",
                        color: colors.primaryColor
                      }}
                    />
                  }
                  label={<Ptag fontSize="12px" fontFamily="Montserrat">{status}</Ptag>}
                />
              ))}
            </FormGroup>
          </FormControl>
        </section>
      </Popover>
      : null
      }
      <Button
        variant="contained"
        startIcon={<FilterListIcon color="black" />}
        onClick={filterHandler}
        sx={{
          // backgroundColor: colors.whiteColor,
          backgroundColor: "transparent",
          fontSize: "14px",
          textTransform: "capitalize",
          fontFamily: "Inter",
          border: "1px solid rgba(255, 255, 255, 1)",
          color: "#344054",
          boxShadow: "0",
          borderRadius: "8px",
          padding: "8px 12px 8px 12px",
          // "&:hover": {
          //   boxShadow: "0",
          //   backgroundColor: "white",
          // },
          boxShadow:
            "inset 2px 2px 5px rgba(0, 0, 0, 0.08), inset -1px -1px 3px rgba(255, 255, 255, 0.9)",
          "&:hover": {
            boxShadow:
              "inset 2px 2px 5px rgba(0, 0, 0, 0.08), inset -1px -1px 3px rgba(255, 255, 255, 0.9)",
            backgroundColor: "transparent",
          },
        }}
      >
        Status
        {filterStatusSelected.size > 0 && (
          <FilterBadgeWrapper>
            <p>{filterStatusSelected.size}</p>
          </FilterBadgeWrapper>
        )}
      </Button>
    </>
  );
}

export default FilterBar;
